import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import RichContent from '../components/RichContent';
import ShareButton from '../components/ShareButton';

export default function ArticleDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    fetch(`/api/articles/${slug}`).then(r => {
      if (!r.ok) throw new Error('Introuvable');
      return r.json();
    }).then(setArticle).catch(e => setError(e.message));
  }, [slug]);

  if (error) return <div className="article-detail"><h1>Oups.</h1><p>{error}</p><Link to="/articles" className="btn">← retour</Link></div>;
  if (!article) return <div className="article-detail">chargement...</div>;

  return (
    <article className="article-detail fade-in">
      <Link to="/articles" style={{ fontFamily: 'var(--font-mono)', fontSize: '.85rem', textDecoration: 'underline' }}>← tous les articles</Link>
      <div className="date" style={{ marginTop: '2rem' }}>
        {new Date(article.created_at).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
      </div>
      <h1>{article.title}</h1>
      <div className="share-row"><ShareButton title={article.title} text={article.excerpt || article.title} /></div>
      {article.cover_image && <img src={article.cover_image} alt={article.title} />}
      <RichContent className="content" html={article.content} />
      {article.tags && (
        <div className="card-tags" style={{ marginTop: '3rem' }}>
          {article.tags.split(',').map((t, i) => <span key={i} className="card-tag">#{t.trim()}</span>)}
        </div>
      )}
      <div className="share-end">
        <p>Cet article vous a plu ? Faites-le circuler ✦</p>
        <ShareButton title={article.title} text={article.excerpt || article.title} label="partager l'article" />
      </div>
    </article>
  );
}
